import React from 'react';
import { ICoupon } from 'mod/coupon/interface';
import ThemeEmpty from '@base/lib/ThemeEmpty';
import CouponItem from '@base/account/coupons/CouponItem';

type CouponListProps = {
    isShowNotUseText?: boolean;
    className?: string;
    isShowCopy?: boolean;
    list: ICoupon[];
    selected?: ICoupon;
    onSelectCoupon?: (couponCode: string) => void;
};

export const CouponList: React.FC<CouponListProps> = props => {
    const {
        className,
        list,
        ...rest
    } = props;

    return list.length === 0 ? <ThemeEmpty type="coupon"/> : (
        <div role={'group'} className={className}>
            {list.map(item => (
                <CouponItem
                    key={item.code}
                    item={item}
                    {...rest}
                />
            ))}
        </div>
    )
};

export default CouponList;